// How the profile menu shows the WhatsApp numbers of a space or of a sede:
// a flag and the local number.

// Map of country codes to flag emojis
const countryCodeToFlag = {
  '1': '🇺🇸',     // USA/Canada
  '52': '🇲🇽',    // Mexico
  '521': '🇲🇽',   // Mexico mobile
  '54': '🇦🇷',    // Argentina
  '55': '🇧🇷',    // Brazil
  '56': '🇨🇱',    // Chile
  '57': '🇨🇴',    // Colombia
  '58': '🇻🇪',    // Venezuela
  '51': '🇵🇪',    // Peru
  '34': '🇪🇸',    // Spain
  '44': '🇬🇧',    // UK
  '49': '🇩🇪',    // Germany
  '33': '🇫🇷',    // France
  '39': '🇮🇹',    // Italy
  '81': '🇯🇵',    // Japan
  '86': '🇨🇳',    // China
  '91': '🇮🇳',    // India
};

export const getCountryFlag = (phone) => {
  // Clean phone number - remove all non-digit characters
  const cleanPhone = String(phone).replace(/\D/g, '');

  // Check for 3-digit codes first (like 521 for Mexico mobile)
  if (countryCodeToFlag[cleanPhone.slice(0, 3)]) {
    return { flag: countryCodeToFlag[cleanPhone.slice(0, 3)], numberStart: 3, cleanPhone };
  }
  // Then 2-digit codes
  if (countryCodeToFlag[cleanPhone.slice(0, 2)]) {
    const twoDigitCode = cleanPhone.slice(0, 2);

    // Special case: Numbers starting with 55 that are 10 digits are likely Mexican (CDMX area code)
    // Brazilian numbers need 12-13 digits to be complete (55 + 2-digit area + 8-9 local)
    if (twoDigitCode === '55' && cleanPhone.length === 10) {
      // This is likely a Mexican number from CDMX (area code 55 + 8 digits)
      return { flag: '🇲🇽', numberStart: 0, cleanPhone };
    }

    return { flag: countryCodeToFlag[twoDigitCode], numberStart: 2, cleanPhone };
  }
  // Then 1-digit codes
  if (countryCodeToFlag[cleanPhone.slice(0, 1)]) {
    return { flag: countryCodeToFlag[cleanPhone.slice(0, 1)], numberStart: 1, cleanPhone };
  }
  return { flag: '🇲🇽', numberStart: 0, cleanPhone }; // Default to Mexico flag
};

// A space brings the platform as an object with `name`; a sede of the partner
// directory brings the name itself.
const isWhatsapp = (platform) => (platform?.name ?? platform) === 'WHATSAPP';

/** The phones of the active WhatsApp channels, as they come. */
export const getWhatsappPhones = (channels) => (channels || [])
  .filter((channel) => channel?.isActive && isWhatsapp(channel?.platform) && channel?.phone)
  .map((channel) => channel.phone);

const formatPhone = (phone) => {
  const { flag, numberStart, cleanPhone } = getCountryFlag(phone);
  const localNumber = cleanPhone.slice(numberStart);
  return `${flag} ${localNumber}`;
};

/** `🇲🇽 5512345678, 🇨🇴 3001234567`, or `null` without an active WhatsApp. */
export const formatWhatsappPhones = (channels) => {
  const phones = getWhatsappPhones(channels);
  if (phones.length === 0) return null;
  return phones.map(formatPhone).join(', ');
};

/**
 * For a row with room for one line: `{ first: '🇲🇽 5512345678', more: 10 }`
 * (the first phone and how many more there are), or `null` without any.
 */
export const summarizeWhatsappPhones = (channels) => {
  const phones = getWhatsappPhones(channels);
  if (phones.length === 0) return null;
  return { first: formatPhone(phones[0]), more: phones.length - 1 };
};
